// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__Lzuxk","actionsCol":"EnrolledClinics_actionsCol__1uHzj"};